import {
  Button,
  DataGrid,
  ScrollView,
  Popup,
  Form,
  SelectBox,
  NumberBox,
  TextBox,
} from "devextreme-react";
import {
  Column,
  ColumnChooser,
  Export,
  FilterRow,
  HeaderFilter,
  Paging,
} from "devextreme-react/data-grid";
import React, { useEffect, useState } from "react";
import {
  articulos,
  empresa,
  inventario as initialInventario,
  tipo,
} from "./data_test";
import { GroupItem, Item, Label } from "devextreme-react/form";

import * as DinamicQueries from "../../api/DinamicsQuery";
import * as ReportsService from "../../api/reports";

const InventarioTotal = () => {
  const [showPopup, setShowPopup] = useState(false);
  const [dataForm, setDataForm] = useState({
    empresa: "",
    region: "",
    regionTrans: "",
    responsable: "",
    cantidad_a_transferir: 0,
    tipo_articulo: "",
    articulo: "",
    detalle_orden: [{ cantidad: 0 }],
  });
  const [regiones, setRegiones] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [usuarios, setUsuarios] = useState([]);
  const [inventario, setInventario] = useState([]);

  useEffect(() => {
    // Obtener regiones
    ReportsService.getInventario()
      .then((resp) => {
        console.log("🚀 ~ ReportsService.getInventario ~ resp:", resp.data);
        setInventario(resp.data.data);
      })
      .catch((error) => console.error("Error en getInventario:", error));
    ReportsService.getRegion()
      .then((resp) => {
        console.log("🚀 ~ ReportsService.getRegion ~ resp:", resp.data);
        setRegiones(resp.data);
      })
      .catch((error) => console.error("Error en getRegion:", error));
    ReportsService.getUsers()
      .then((resp) => {
        console.log("🚀 ~ ReportsService.getUsers ~ resp:", resp.data);
        setUsuarios(resp.data);
      })
      .catch((error) => console.error("Error en getUsers:", error));

    ReportsService.getClients()
      .then((resp) => {
        console.log("🚀 ~ ReportsService.getClients ~ resp:", resp.data);
        setClientes(resp.data);
      })
      .catch((error) => console.error("Error en getClients:", error));
  }, []);

  const openPopup = () => {
    resetForm();
    setShowPopup(true);
  };

  const resetForm = () => {
    setDataForm({
      empresa: "",
      region: "",
      regionTrans: "",
      responsable: "",
      tipo_articulo: "",
      articulo: "",
      cantidad_a_transferir: 0,
      detalle_orden: [{ cantidad: 0 }],
      cedula_responsable: "",
    });
  };
  const hidePopup = () => {
    resetForm(); // Primero resetea el formulario
    setShowPopup(false); // Luego cierra el popup
  };
  // EMPRESAS únicas
  const empresasUnicas = [
    ...new Set(inventario.map((item) => item.empresa)),
  ].map((empresa) => ({ value: empresa, name: empresa }));

  // REGIONES según EMPRESA seleccionada
  const regionesFiltradas = [
    ...new Set(
      inventario
        .filter((item) => item.empresa === dataForm.empresa)
        .map((item) => item.region)
    ),
  ].map((region) => ({ nombre_region: region }));

  // TIPOS DE ARTÍCULO según EMPRESA y REGIÓN
  const tiposFiltrados = [
    ...new Set(
      inventario
        .filter(
          (item) =>
            item.empresa === dataForm.empresa && item.region === dataForm.region
        )
        .map((item) => item.tipo_articulo)
    ),
  ].map((tipo) => ({ value: tipo, name: tipo }));

  // ARTÍCULOS según EMPRESA, REGIÓN y TIPO DE ARTÍCULO
  const articulosFiltrados = [
    ...new Set(
      inventario
        .filter(
          (item) =>
            item.empresa === dataForm.empresa &&
            item.region === dataForm.region &&
            item.tipo_articulo === dataForm.tipo_articulo
        )
        .map((item) => item.articulo)
    ),
  ].map((art) => ({ value: art, name: art }));

  const handleSubmit = () => {
    const { cantidad_a_transferir, detalle_orden, ...rest } = dataForm;

    const detalleTransferencia = [
      {
        ...detalle_orden[0], // se usa estructura completa del detalle del inventario
        cantidad: cantidad_a_transferir,
      },
    ];

    const newMovimiento = {
      ...rest,
      detalle_orden: detalleTransferencia,
    };

    ReportsService.transferInventario(newMovimiento)
      .then((response) => ReportsService.getInventario())
      .then((resp) => {
        setInventario(resp.data.data); // Actualizar el inventario
        hidePopup(); // Ocultar el popup
      })
      .catch((error) => {
        console.error("Error al guardar inventario:", error);

        // Mostrar el mensaje de error de la API
        if (error.response && error.response.data && error.response.data.msg) {
          alert(error.response.data.msg); // Mostrar el mensaje de error
        } else {
          alert("Hubo un error al procesar la transferencia"); // Mensaje genérico en caso de otro tipo de error
        }
      });
  };

  const userFilters = usuarios.filter(
    (usuario) =>
      (usuario.rol === "Supervisor" || usuario.rol === "Coordinador") &&
      usuario.region === dataForm.region
  );

  console.log(userFilters);

  const renderContent = () => {
    return (
      <ScrollView height="100%" width="100%">
        <Form className="form-container" style={{ height: "100%" }}>
          <GroupItem colCount={3}>
            <Item>
              <Label text="Empresa" />
              <SelectBox
                dataSource={empresasUnicas}
                valueExpr="value"
                displayExpr="name"
                value={dataForm.empresa}
                onValueChanged={(e) =>
                  setDataForm({
                    ...dataForm,
                    empresa: e.value,
                    region: null,
                    tipo_articulo: null,
                    articulo: null,
                  })
                }
              />
            </Item>

            <Item>
              <Label text="Región" />
              <SelectBox
                searchEnabled={true}
                dataSource={regionesFiltradas}
                valueExpr="nombre_region"
                displayExpr="nombre_region"
                value={dataForm.region}
                onValueChanged={(e) =>
                  setDataForm({
                    ...dataForm,
                    region: e.value,
                    tipo_articulo: null,
                    articulo: null,
                  })
                }
              />
            </Item>

            <Item>
              <Label text="Región a Transferir" />
              <SelectBox
                searchEnabled={true}
                dataSource={regiones}
                valueExpr="nombre_region" // Ahora se usa el nombre como valor
                displayExpr="nombre_region" // Se sigue mostrando el nombre
                value={dataForm.regionTrans}
                onValueChanged={
                  (e) => setDataForm({ ...dataForm, regionTrans: e.value }) // Guarda el nombre de la región
                }
              />{" "}
            </Item>
          </GroupItem>
          <GroupItem colCount={2}>
            <Item>
              <Label text="Tipo de artículo" />
              <SelectBox
                dataSource={tiposFiltrados}
                valueExpr="value"
                displayExpr="name"
                value={dataForm.tipo_articulo}
                onValueChanged={(e) =>
                  setDataForm({
                    ...dataForm,
                    tipo_articulo: e.value,
                    articulo: null,
                  })
                }
              />
            </Item>

            <Item>
              <Label text="Artículos" />
              <SelectBox
                dataSource={articulosFiltrados}
                valueExpr="value"
                displayExpr="name"
                value={dataForm.articulo}
                onValueChanged={(e) => {
                  const articuloSeleccionado = inventario.find(
                    (item) =>
                      item.empresa === dataForm.empresa &&
                      item.region === dataForm.region &&
                      item.tipo_articulo === dataForm.tipo_articulo &&
                      item.articulo === e.value
                  );

                  const cantidadDisponible =
                    articuloSeleccionado?.detalle_orden?.[0]?.cantidad || 0;

                  setDataForm({
                    ...dataForm,
                    articulo: e.value,
                    detalle_orden: [
                      {
                        cantidad: cantidadDisponible,
                      },
                    ],
                  });
                }}
              />
            </Item>
          </GroupItem>
          <GroupItem colCount={3}>
            <Item>
              <Label>Cantidad</Label>
              <NumberBox
                readOnly={true}
                value={dataForm.detalle_orden[0].cantidad}
                hoverStateEnabled={false}
              />
            </Item>

            <Item>
              <Label>Cantidad a Transferir</Label>
              <NumberBox
                showClearButton={true}
                value={dataForm.cantidad_a_transferir || 0}
                onValueChanged={(e) => {
                  const nuevaCantidad = e.value || 0;
                  setDataForm({
                    ...dataForm,
                    cantidad_a_transferir: nuevaCantidad,
                  });
                }}
              />
            </Item>

            <Item>
              <Label>Restante</Label>
              <NumberBox
                showClearButton={true}
                value={
                  (dataForm.detalle_orden[0].cantidad || 0) -
                  (dataForm.cantidad_a_transferir || 0)
                }
                readOnly={true}
                hoverStateEnabled={false}
                inputAttr={{
                  style:
                    "color:" +
                    ((dataForm.detalle_orden[0].cantidad || 0) -
                      (dataForm.cantidad_a_transferir || 0) <
                    0
                      ? "red"
                      : "black"),
                }}
              />
            </Item>
          </GroupItem>

          <GroupItem colCount={2}>
            {/* Responsable */}
            <Item>
              <Label text="Responsable" />
              <SelectBox
                searchEnabled={true}
                dataSource={userFilters}
                disabled={!dataForm.region}
                valueExpr="cedula" // Usar la cédula como identificador único
                displayExpr={
                  (item) => (item ? `${item.nombre} ${item.apellido}` : "") // Mostrar nombre y apellido
                }
                value={dataForm.cedula_responsable} // Vincular al estado con la cédula
                onValueChanged={(e) => {
                  const usuarioSeleccionado = usuarios.find(
                    (user) => user.cedula === e.value
                  );
                  setDataForm({
                    ...dataForm,
                    responsable: usuarioSeleccionado
                      ? `${usuarioSeleccionado.nombre} ${usuarioSeleccionado.apellido}`
                      : "", // Guarda el nombre completo del responsable
                    cedula_responsable: e.value, // Guarda la cédula asociada
                  });
                }}
              />
            </Item>

            <Item>
              <Label text="Cédula Responsable" />
              <TextBox
                value={dataForm.cedula_responsable}
                readOnly={true}
                hoverStateEnabled={false}
              />
            </Item>
          </GroupItem>
        </Form>
      </ScrollView>
    );
  };

  return (
    <div>
      <div className="d-flex gap-2 mt-3">
        <Button className="btn btn-primary" onClick={openPopup}>
          Transferencia
        </Button>
      </div>

      <DataGrid
        className="tabla-Cliente"
        dataSource={inventario}
        showBorders={true}
        remoteOperations={false} // Ahora los datos ya están procesados en el front
        focusedRowEnabled={true}
        style={{ height: "430px", width: "100%" }}
        keyExpr="id"
        wordWrapEnabled={true}
      >
        <Export enabled={true} />
        <ColumnChooser enabled={true} mode="select" />
        <FilterRow visible={true} />
        <Paging defaultPageSize={12} />
        <HeaderFilter visible={true} />

        <Column caption="Empresa" dataField="empresa" dataType="string" />
        <Column caption="Región" dataField="region" dataType="string" />
        <Column
          caption="Tipo Artículo"
          dataField="tipo_articulo"
          dataType="string"
        />
        <Column caption="Artículo" dataField="articulo" dataType="string" />
        <Column
          caption="Cantidad"
          dataField="detalle_orden[0].cantidad"
          dataType="number"
        />
      </DataGrid>

      <Popup
        width={"80%"}
        height={"70%"}
        visible={showPopup}
        onHiding={hidePopup}
        showCloseButton={true}
        contentRender={renderContent}
        toolbarItems={[
          {
            widget: "dxButton",
            toolbar: "bottom",
            location: "after",
            options: {
              text: "Guardar",
              onClick: handleSubmit,
            },
          },
          {
            widget: "dxButton",
            toolbar: "bottom",
            location: "after",
            options: {
              text: "Cancelar",
              onClick: hidePopup,
            },
          },
        ]}
      />
    </div>
  );
};

export default InventarioTotal;
